



































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

import Preview from "./preview.vue";

@Component({
  components: {
    Add,
    Edit,
    Preview
  }
})
export default class extends Mixins(MyList) {
  copyModalVisible = false;

  newModalVisible = false;

  previewModalVisible = false;

  categories: any[] = [
    { id: "0", name: "其他海报" },
    { id: "1", name: "俱乐部招募成员" },
    { id: "2", name: "场馆招募球友" },
    { id: "3", name: "场馆招募会员" },
    { id: "4", name: "形象海报" },
    { id: "5", name: "培训授权海报" }
  ];

  dispatchType = "poster/list";

  dispatchTypeDelete = "poster/delete";

  deleteConfirmContent = "确定要删除该海报吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "title" },
    { title: "示例图片", scopedSlots: { customRender: "picurl" } },
    { title: "分类", scopedSlots: { customRender: "category_id" } },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "排序", dataIndex: "sortid" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showCopyModal(id: number) {
    this.editId = id;
    this.copyModalVisible = true;
  }

  hideCopyModal() {
    this.editId = 0;
    this.copyModalVisible = false;
    this.loadData();
  }

  showPreviewModal(id: number) {
    this.editId = id;
    this.previewModalVisible = true;
  }

  hidePreviewModal() {
    this.previewModalVisible = false;
  }

  showNewModal() {
    // this.newModalVisible = true;
  }

  hideNewModal() {
    // this.newModalVisible = false;
  }

  mounted() {
    this.loadData();
  }
}
